vue
<template>
    <!-- Main section start -->
    <section class="h-screen px-12 lg:px-32 py-32 mb-8">
        <div class="w-full md:w-1/2 h-full flex flex-col md:justify-center ">
            <!-- Main text start -->
            <h1 class="uppercase text-5xl xl:text-7xl mb-4 font-semibold ">
                {{ $t('main.title') }}
            </h1>
            <p class="capitalize xl:w-1/2 text-stone-500">
                {{ $t('main.subtitle') }}
            </p>
            <!-- Main text end -->
        </div>
    </section>
    <!-- Main section end -->
</template>

<script>
export default {
}
</script>